import React, { useContext, useEffect, useState } from "react";
import { Switch, Redirect } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { PublicRoute } from "src/components";
import { Appheader } from "src/components/header/appheader/Appheader";
import { Route } from "src/config/routes";
import { RootStoreContext } from "src/stores/RootStore";
import { useHistory } from "react-router-dom";
import { Footer } from "src/components/footer/Footer";
import * as Screens from "src/screens";
import { Process } from "src/screens/process/Process";
import { Service } from "src/screens/service/Service";
import { NetworkConfig } from "src/network/NetworkConfig";
import i18n from "src/utils/i18n";
import { useLanguageDropdownItems } from "src/hooks/translation/useLanguageDropdownItems";
import { Logout } from "./auth/logout/Logout";

export const RoutesBase = () => {
    const { uiStore, navStore, easyContactStore } = useContext(RootStoreContext);
    const history = useHistory();
    const { languageDropdownItems } = useLanguageDropdownItems();
    const [hasSystemHealthBeenChecked, setHasSystemHealthBeenChecked] = useState<boolean>(false);

    useEffect(() => {
        if (!hasSystemHealthBeenChecked) {
            const checkSystemHealth = async () => {
                if (!NetworkConfig.isMaintenanceActive) {
                    try {
                        const getSystemHealthResponse = await fetch(NetworkConfig.systemHealthUrl, { method: "GET" });

                        if (getSystemHealthResponse.status !== 200) {
                            setHasSystemHealthBeenChecked(true);
                            history.push(Route.systemHealthError);
                        }
                    } catch (error) {
                        setHasSystemHealthBeenChecked(true);
                        history.push(Route.systemHealthError);
                    }
                }
            };

            checkSystemHealth();
            setHasSystemHealthBeenChecked(true);
        }
    }, [hasSystemHealthBeenChecked, history]);

    useEffect(() => {
        if (easyContactStore.applicationLanguage) {
            i18n.changeLanguage(easyContactStore.applicationLanguage);

            uiStore.setCurrentLanguageDropdownValue(
                languageDropdownItems.find(
                    (languageDropdownItem) => languageDropdownItem.value === easyContactStore.applicationLanguage
                )?.label ?? ""
            );

            uiStore.setDisplayChangeLanguageDropdown(true);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const unlisten = history.listen(() => {
            window.scrollTo(0, 0);
        });
        return unlisten;
    }, [history]);

    return (
        <main className="d-flex flex-column" style={{ background: uiStore.backgroundColor }}>
            <Appheader />
            <div className="flex-grow-1 d-flex flex-column" style={{ marginTop: uiStore.headerHeight }}>
                {navStore.active ? (
                    <Switch>
                        <PublicRoute path={Route.start} component={Screens.Start} />
                        <PublicRoute path={Route.process} component={Process} />
                        <PublicRoute path={Route.service} component={Service} />
                        <PublicRoute path={Route.logout} component={Logout} />
                        <PublicRoute path={Route.systemHealthError} component={Screens.SystemHealthError} />
                        <PublicRoute path={Route.root}>
                            <Redirect to={Route.start} />
                        </PublicRoute>
                    </Switch>
                ) : (
                    <PublicRoute path="*" component={Screens.Inactive} />
                )}
            </div>
            <Footer />
        </main>
    );
};

export const Routes = Sentry.withProfiler(observer(RoutesBase));
